import { instance as fileAttachInstance } from './fileAttach'
import { parseHTML } from '../utils/parseHTML'

export default class FormSend {
  constructor () {
    let self = this

    $(document).on('form::valid', '[data-form]:not([data-form-no-ajax], [data-js-catalog-form])', function () {
      const form = $(this)
      const formData = new FormData(form[0])
      self.send(form, formData)
    })

  }

  extendFiles (form, formData) {
    const $files = form.find(fileAttachInstance)

    $files.each((index, fileElem) => {
      const fileAttacher = App.Forms.FileAttachCollection.getByDOMElement(fileElem)
      const $input = fileAttacher.$input
      const name = $input.attr('name')

      if (fileAttacher.isMultiple) {
        formData.delete(name)

        fileAttacher.files.forEach(file => {
          formData.append(name, file.file)
        })
      }
    })
  }

  resetFiles (form) {
    const $files = form.find(fileAttachInstance)

    $files.each((index, fileElem) => {
      const fileAttacher = App.Forms.FileAttachCollection.getByDOMElement(fileElem)
      fileAttacher.clear()
    })
  }

   static replaceNodes (elements) {
    elements.forEach((item) => {
      const {selector, html} = item;
      const dest = document.querySelector(selector);
      const newNodes = parseHTML(html);
      if (dest && newNodes.length) {
        dest.replaceWith(newNodes[0]);
      } else {
        console.debug("Can't find nodes with selector: ", dest);
      }
    });
  }

  send (form, formData) {
    const self = this
    if (!form.attr('data-ajax-no-loader')) {
      /*App.Loader.showLoader();*/
    }

    const haveFiles = !!form.find(fileAttachInstance).length
    if (haveFiles) {
      this.extendFiles(form, formData)
    }
    $.ajax({
      type: 'POST',
      data: formData,
      url: form.attr('data-ajax-url') || (window.SITE_TEMPLATE_PATH ? window.SITE_TEMPLATE_PATH + '/ajax/form.php' : ''),
      processData: false,
      contentType: false,
      beforeSend: function () {
        // Удаляем блок с ошибками перед отправкой
        form.find('.form-row--errors').remove()
      },
      success: function (data) {
        if (!form.attr('data-ajax-no-loader')) {/*App.Loader.hideLoader();*/}
        if (data.checkoutSuccess) {
          $(document).trigger('trigger::checkout', [data.checkoutSuccess])
        }
        if (data?.success) {
          // Очищаем форму
          if (!form[0].hasAttribute('data-ajax-noclean')) {
            form[0].reset()
            self.resetFiles(form)
          }

          $.fancybox.close()
          if (data.modal) {
            $.fancybox.close()
            $.fancybox.open({
              src: $(data.modal),
              type: 'inline',
              opts: {
                afterClose: function (instance, current) {
                  if (current.src[0].dataset.hasOwnProperty('jsReloadPage')) {
                    window.location.reload()
                  }
                }
              }
            })
          }
          if (data.replaceElements) {
            FormSend.replaceNodes(data.replaceElements)
          }
        } else {

          if (data?.modal) {
            $.fancybox.close()
            $.fancybox.open({
              src: $(data.modal),
              type: 'inline',
              opts: {
                afterClose: function (instance, current) {
                  if (current.src[0].dataset.hasOwnProperty('jsReloadPage')) {
                    window.location.reload()
                  }
                }
              }
            })
          }
          form[0].reset()
          self.resetFiles(form)
        }

      },
      error: function () {
        self.resetFiles(form)
        $.fancybox.close()
        $.fancybox.open({
          src: '#modal-error',
          type: 'inline'
        })
      }
    })
  }
}
